import Swiper from "../../../../../assets/vendor/swiper/swiper-bundle.esm.browser";

export default class VideoSlider {
    /**
     * Cosstructor
     * @param $slider
     */
    constructor($slider) {
        this.$slider = $slider;

        this.slider = (new Swiper(this.$slider, {
            slidesPerView: 1,
            spaceBetween: 120,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                900: {
                    slidesPerView: 3,
                }
            }
        }))
    }
}